import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import './global.scss'
import axios from 'axios';

function PaymentRedirect() {
    const [searchParams] = useSearchParams();
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate()
    useEffect(()=>{
        handleRedirect();      
    // eslint-disable-next-line
    },[])
  // Extract the parameters
  
  const handleRedirect = async ()=>{
      setIsLoading(true)
    //   const institution = searchParams.get('institution');
    //   const consentId = searchParams.get('consentid');
    //   const userUuid = searchParams.get('user-uuid');
    //   const applicationUserId = searchParams.get('application-user-id');
      const consent = searchParams.get('consent');
      const transactionId = searchParams.get('application-user-id');
    try{

        let data ={
            transactionId:transactionId,
            consent:consent
        }

        const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/v2/initiate-payment-others-2"
        const res = await axios.post(url,data)

        const {status,reference} = res.data?.data?.data || res.data?.data
        const {redirectUrl} = res.data?.data
        const result ={
          reference:reference || '',
          redirectUrl:redirectUrl || '' 
        }
        setIsLoading(false)
        // console.log("response Data: ",res.data);
        navigate('/pages/payment-success')
        if(status){
          if(status  === "PENDING"){
            navigate('/pages/pending',{state:{result}})
          }else if(status === "FAILED" || status ==="DECLINED"){
            navigate('/pages/failed',{state:{result}})
          }else if(status === "COMPLETED" || status === "COMPLETED_SETTLEMENT_IN_PROCESS"){
            navigate('/pages/successful',{state:{result}})
          }else {
            navigate('/pages/transaction-failed',{state:{result}})
          }
        }else {
          navigate('/pages/transaction-failed',{state:{result}})
        }
    }catch(err){
        setIsLoading(false)
        console.log(err);
        navigate('/pages/transaction-failed')
    }

  }
  return (
    <div className="loader">
          <div className='loading_overlay' style={{background:"#e9e9e9"}}>
             
                {
                    isLoading &&
                    <FadeLoader
                    cssOverride={{marginRight:"auto",marginLeft:"auto"}}
                    color="#259792"
                    />
                }
              
          </div>
   </div>
  )
}

export default PaymentRedirect